import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { z } from 'zod';

export const Route = createFileRoute('/shared/flatfinder/$publicId/')({
  validateSearch: zodValidator(z.object({ embed: z.string().optional() })),
});
